import { render, staticRenderFns } from "./PwdSetting.vue?vue&type=template&id=5477b768&scoped=true"
import script from "./PwdSetting.vue?vue&type=script&lang=js"
export * from "./PwdSetting.vue?vue&type=script&lang=js"
import style0 from "./PwdSetting.vue?vue&type=style&index=0&id=5477b768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477b768",
  null
  
)

export default component.exports